export const FILTERABLE_COLUMNS = {
  BRAND: 'brand',
  SLOT_NAMES: 'slotNames',
  GTM_STATUS: 'gtmStatus',
} as const;